var CustomReuseStrategy = /** @class */ (function () {
    function CustomReuseStrategy() {
        this.routesToCache = ['geobrain-key', 'documents-key'];
        this.storedRouteHandles = new Map();
    }
    // Decides if the route should be stored
    CustomReuseStrategy.prototype.shouldDetach = function (route) {
        return this.routesToCache.indexOf(route.data['key']) > -1;
    };
    // Store the information for the route we're destructing
    CustomReuseStrategy.prototype.store = function (route, handle) {
        this.storedRouteHandles.set(route.data['key'], handle);
    };
    // Return true if we have a stored route object for the next route
    CustomReuseStrategy.prototype.shouldAttach = function (route) {
        return this.storedRouteHandles.has(route.data['key']);
    };
    // If we returned true in shouldAttach(), now return the actual route data for restoration
    CustomReuseStrategy.prototype.retrieve = function (route) {
        return this.storedRouteHandles.get(route.data['key']);
    };
    // Reuse the route if we're going to and from the same route
    CustomReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return future.routeConfig === curr.routeConfig;
    };
    return CustomReuseStrategy;
}());
export { CustomReuseStrategy };
